import React, {createContext, useReducer} from 'react';
import Layout from '../Shared/Layout';
import {Container} from "@material-ui/core";
import styled from "styled-components";
import FormPage from "../Shared/FormPage";
import BackButton from "../Shared/BackButton";
import {DynamicColorPreset} from "../Shared/DynamicColorPreset";
import { Trans } from "../utils/i18n";
import MuiButton from "@material-ui/core/Button";
import {Inertia} from "@inertiajs/inertia";
import WarningIcon from '@material-ui/icons/Warning';
import CheckIcon from '@material-ui/icons/Check';
import {Button} from "@mui/material";
import {appointment} from "../config/appointment";
import dayjs from "dayjs";
import {InertiaLink} from "@inertiajs/inertia-react";

const Wrapper = styled.div`
`;

export default function AppointmentCancel({ appointment, cancelUrl, }) {
    if(appointment.status === 'completed' || appointment.status === 'customerNotAvailable') {
        return (
            <Wrapper>
                <Container maxWidth="md">
                    <h1>
                        <Trans i18nKey="appointment.yourBookedAppointment">Your appointment</Trans>
                    </h1>
                    <p className={'text-lg font-medium'}>
                        <Trans i18nKey="appointment.completedMessage">Your appointment was completed. If you still have a problem, then make a new appointment:</Trans>
                    </p>
                    <Button variant={'contained'} color={'primary'} href={route('appointment')} component={InertiaLink}>
                        <Trans i18nKey="appointment.makeNewAppointment">Make a new appointment</Trans>
                    </Button>
                </Container>
            </Wrapper>
        )
    }
    if(appointment.status === 'cancelled') {
        return (
            <Wrapper>
                <Container maxWidth="md">
                    <h1>
                        <Trans i18nKey="appointment.cancel.success">You have successfully canceled the
                            appointment.</Trans>
                    </h1>
                    <p className={'text-lg font-medium'}>
                        <Trans i18nKey="appointment.makeNewAppointment.intro">Click the following button if you would like to make a new appointment</Trans>
                    </p>
                    <Button variant={'contained'} color={'primary'} href={route('appointment')} component={InertiaLink}>
                        <Trans i18nKey="appointment.makeNewAppointment">Make a new appointment</Trans>
                    </Button>
                </Container>
            </Wrapper>
        )
    }

    return (
        <Wrapper>
            <Container maxWidth="md">
                <h1>
                    <Trans i18nKey="appointment.yourBookedAppointment">Your appointment</Trans>
                </h1>
                <p className={'text-lg font-medium'}>{dayjs(appointment?.timeslot?.start_time).format('DD.MM.YYYY HH:mm')} - {dayjs(appointment?.timeslot?.end_time).format('HH:mm')}</p>
                <p className={'text-lg font-medium'}><b><Trans i18nKey="orderEntry.addressContact.phone">Phone</Trans>:</b> {appointment.phone}</p>
                <p className={'text-lg font-medium'}>
                    <Trans i18nKey="appointment.form.appointment-cancel.desriptiob">Are you sure you want to cancel this
                        appointment?</Trans>
                </p>
                <Button variant={'contained'} color={'secondary'} onClick={() => Inertia.post(cancelUrl)}>
                    <Trans i18nKey="appointment.toCancel">Cancel</Trans>
                </Button>
            </Container>
        </Wrapper>
    )
}


AppointmentCancel.layout = page => <Layout children={page}/>;
